const FILE_TYPE = {
  // SKU
  商品图片: '2',
  SKU导入: '10',
  商品上市时间: '11',
  商品发货周期: '12',
  商品销售价: '13',
  商品采购价: '14',
  商品清仓销售状态: '15',
  商品店铺定位: '16',
  商品品类风格: '17',
  // 产品
  产品图片: '1',
  产品属性: '21',
  产品清仓信息: '22',
  产品零售指导价: '23',
  产品上市时间: '24',
  // 订单交期
  计划部缺货回复: '31',
  七天发货区域: '32',
  出货时间: '33',
  // 预销计划
  预销计划商品信息: '40',
  预销计划包件信息: '41',
  销售目标: '42',
  包件在产状态: '43',
};
export {
  FILE_TYPE
};
